import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TableSortModel } from '../typings/intelligence.table-sort';

@Component({
  selector   : 'wor-intelligence-sort-header',
  template: require('./intelligence.sort-header.component.html')
})
export class SortHeaderComponent {
  @Input() field : string;
  @Input() sort  : TableSortModel;

  @Output() sorted = new EventEmitter<string>();
}
